import { Table as MantineTable } from "@mantine/core"
import classes from "./table.module.css"

export const Table = MantineTable.extend({
  classNames: classes,
  defaultProps: {
    highlightOnHover: true,
  },
})
